import { FC, useState } from "react"

import { ToastContext, ToastState } from "./toast-context"

export const ToastProvider: FC = ({ children }) => {
	const toastState = useState<ToastState>(null)

	return <ToastContext.Provider value={toastState}>{children}</ToastContext.Provider>
}
